import { render, staticRenderFns } from "./AutoLogout.vue?vue&type=template&id=08cf49f4&scoped=true&"
import script from "./AutoLogout.vue?vue&type=script&lang=js&"
export * from "./AutoLogout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cf49f4",
  null
  
)

export default component.exports